import PriceFormat from "../../../utils/priceFormat";
import { STOCK_PRICE_LOCKED_MESSAGE } from "../../../data/useStockPermissions";

// Stands in for a price NumberInput when Stock:AdminOnlyChanges locks the price. Plain text rather
// than a disabled input: react-hook-form can drop a disabled field's value, saving a blank price.
export default function LockedPriceField({ label, price }: { label: string; price?: number | null }) {
  return (
    <div className="sm:col-span-1">
      <label className="text-sm font-medium text-gray-500">{label}</label>
      <p className="w-full mt-1 border-1 border-gray-300 bg-gray-100 px-3 py-2 text-sm text-gray-700">
        {price != null && price > 0 ? PriceFormat(price) : "-"}
      </p>
      <p className="mt-1 text-xs text-gray-500">{STOCK_PRICE_LOCKED_MESSAGE}</p>
    </div>
  );
}
